import {styled} from "@mui/material";

export const StringsList = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
});

export const StringRow = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
});

export const RemoveStringButton = styled('button')({
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: 4,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&:disabled': {
    cursor: 'not-allowed',
    opacity: 0.3,
  },
});

export const AddStringButton = styled('button')(({ theme }) => ({
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: 0,
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  color: theme.palette.novotalk.$textColorDarkBlue,
  fontSize: 14,
  fontWeight: 'bold',
  marginTop: 4,
  width: 'fit-content',
  '&:hover': {
    opacity: 0.8,
  },
}));
